import { render } from "./Breadcrumbs.vue?vue&type=template&id=1d67f022&scoped=true&ts=true"
import script from "./Breadcrumbs.vue?vue&type=script&lang=ts"
export * from "./Breadcrumbs.vue?vue&type=script&lang=ts"

import "./Breadcrumbs.vue?vue&type=style&index=0&id=1d67f022&scoped=true&lang=scss"

import exportComponent from "/builds/Moodbuster2.0/server/web-server/repos/patient_portal_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d67f022"]])

export default __exports__